import {useDictionary} from '@adamlip/okeoke.client';
import {useNavigate} from 'react-router-dom';

function OrderDone() {
  const {getValue} = useDictionary();
  const navigate = useNavigate();

  return (
    <div className='order-done-container'>
      <div className='order-done-title'>{getValue('app_v2_order_done_title')}</div>
      <div className='order-done-text'>{getValue('app_v2_order_done_text')}</div>
      <div className='btn' onClick={() => navigate('/')}>
        {getValue('app_v2_order_done_btn')}
      </div>
    </div>
  );
}
export default OrderDone;
